import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import React, { useEffect } from "react";
import { registerPlugin } from "react-filepond";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { MainLoader } from "../../../../components";
import {
  getNewsletter,
  resetNewsletter,
} from "../../../../store/newsletter/actions";
registerPlugin(FilePondPluginImagePreview);

function NewsletterDetail(props) {
  useEffect(() => {
    props.getNewsletter(props.match.params.id);
    return () => {
      props.resetNewsletter();
    };
  }, []);

  function renderField(label, value) {
    return (
      <FormGroup row>
        <Col md="2" lg="1">
          <Label color="red">{label}</Label>
        </Col>
        <Col xs="12" md="5">
          <p className="form-control-static">{value}</p>
        </Col>
      </FormGroup>
    );
  }

  function renderFields() {
    return (
      <div>
        {renderField("Titulo:", props.newsletter.title)}
        {renderField("Has-tags:", props.newsletter.hashTags)}
        {renderField("Descripción corta:", props.newsletter.short_desc)}
        {renderField("Texto de la noticia:", props.newsletter.large_desc)}
      </div>
    );
  }

  return props.error ? (
    <Alert color="danger">{error}</Alert>
  ) : props.loading ? (
    <MainLoader />
  ) : (
    <div className="animated">
      <Card>
        <CardHeader>Detalle de la Noticia</CardHeader>
        <CardBody>
          {props.newsletter && (
            <div>
              {renderFields()}
              <FormGroup row>
                <Col md="2" lg="1">
                  <Label>Foto previa:</Label>
                </Col>
                <Col xs="12" md="5">
                  <img
                    style={{ width: "100%" }}
                    src={props.newsletter.preview_img}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col md="2" lg="1">
                  <Label>Foto principal:</Label>
                </Col>
                <Col xs="12" md="5">
                  <img
                    style={{ width: "100%" }}
                    src={props.newsletter.main_img}
                  />
                </Col>
              </FormGroup>
            </div>
          )}
          <Row>
            <Col className="mt-3">
              <Button
                color="secondary"
                onClick={() =>
                  props.history.push("/administration/newsletters")
                }
              >
                <i className="fa fa-chevron-left mr-1" /> Volver
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
}

function mapStateToProps(state) {
  const { newsletter, error, loading } = state.newsletter.activeNewsletter;
  return {
    newsletter,
    error,
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNewsletter,
      resetNewsletter,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterDetail);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterDetail/NewsletterDetail.js